module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/colored-label-buttons/colored-label-buttons.component.scss
// module id = ./src/app/features/buttons/colored-label-buttons/colored-label-buttons.component.scss
// module chunks = main